import React from "react";
import styled from "styled-components";

const ButtonClose = props => (
  <StyledClose {...props}>
    <span></span>
  </StyledClose>
);

export default ButtonClose;

const StyledClose = styled.button`
  position: relative;
  display: inline-block;
  height: 1.625em;
  width: 1.625em;
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 0.2s ease;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: inherit;
    border: 2px solid;
  }
  .can-hover &:hover,
  &:active {
    opacity: 1;
  }
  span::before,
  span::after {
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -1px;
    left: 0.4em;
    right: 0.4em;
    height: 2px;
    background-color: currentColor;
    transition: opacity 0.2s ease;
  }
  span::before {
    transform: rotate(45deg);
  }
  span::after {
    transform: rotate(-45deg);
  }
  .can-hover &:hover span,
  &:active span {
    &::before,
    &::after {
      opacity: 1;
    }
  }
`;